import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/ui/tabs';
import { DevicesTable, GeneralInfo } from 'features/profile';
import { useTranslation } from 'react-i18next';
import { useSecureConfigStore } from 'state/store/config/useConfigStore';

// Map URL parameters to internal tab IDs (outside component to avoid re-creation)
const urlParamToTabId: Record<string, string> = {
  'general-info': 'generalInfo',
  'devices': 'devices',
  'subscription': 'subscription'
};

const tabIdToUrlParam: Record<string, string> = {
  'generalInfo': 'general-info',
  'devices': 'devices',
  'subscription': 'subscription'
};

export function Profile() {
  const { t } = useTranslation();
  const [searchParams, setSearchParams] = useSearchParams();
  const [tabId, setTabId] = useState('generalInfo');
  const { siteConfigurationSettings } = useSecureConfigStore();

  // Check if subscription info should be shown (only show if explicitly true)
  const showSubscriptionInfo = siteConfigurationSettings?.siteConfigurations?.data?.showSubscriptionInfo === true;

  // Initialize tab from URL parameter on component mount
  useEffect(() => {
    const tabParam = searchParams.get('tab');
    if (tabParam && urlParamToTabId[tabParam]) {
      setTabId(urlParamToTabId[tabParam]);
    }
  }, [searchParams, setSearchParams]);

  // Function to handle tab change and update URL
  const handleTabChange = (newTabId: string) => {
    setTabId(newTabId);
    const urlParam = tabIdToUrlParam[newTabId];
    if (urlParam) {
      setSearchParams({ tab: urlParam });
    }
  };

  return (
    <div className="flex w-full flex-col">
      <div className="mb-2 md:mb-[18px] flex items-center text-base text-high-emphasis">
        <h3 className="text-2xl font-bold tracking-tight">{t('MY_PROFILE')}</h3>
      </div>

      <Tabs value={tabId}>
        <div className="my-3 sm:my-5 flex items-center rounded text-base">
          <TabsList className="h-auto rounded-[4px] border border-primary bg-muted/60 px-0.5 py-0.5 shadow-sm">
            <TabsTrigger
              onClick={() => handleTabChange('generalInfo')}
              value="generalInfo"
              className="rounded-[2px] px-4 py-1 text-sm font-medium text-muted-foreground transition-all data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              {t('GENERAL_INFO')}
            </TabsTrigger>
            <TabsTrigger
              onClick={() => handleTabChange('devices')}
              value="devices"
              className="rounded-[2px] px-4 py-1 text-sm font-medium text-muted-foreground transition-all data-[state=active]:bg-primary data-[state=active]:text-primary-foreground data-[state=active]:shadow-sm"
            >
              {t('DEVICES')}
            </TabsTrigger>
            {/* <TabsTrigger onClick={() => handleTabChange('subscription')} value="subscription">
              {t('SUBSCRIPTION')}
            </TabsTrigger> */}
          </TabsList>
        </div>

        <TabsContent value="generalInfo">
          <GeneralInfo />
        </TabsContent>

        <TabsContent value="devices">
          <DevicesTable />
        </TabsContent>
      </Tabs>
    </div>
  );
}
